var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavPerformanceNormal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6B9D68E4-9B70-463B-AA03-FD5BFAC6EF4D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -382.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 371.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NavDocuments",
    transform: "translate(18.000000, 382.000000)",
    fill: "#979598",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C17.5142,3 22,7.4858 22,13 C22,15.4673 21.0923,17.8354 19.4438,19.6685 C19.2461,19.8882 18.9736,20 18.6997,20 C18.4614,20 18.2227,19.9155 18.0317,19.7436 C17.6211,19.3745 17.5874,18.7421 17.9565,18.3315 C19.0494,17.1163 19.7274,15.6051 19.9296,14 L19,14 C18.4478,14 18,13.5522 18,13 C18,12.4478 18.4478,12 19,12 L19.9305,12 C19.7475,10.5425 19.1718,9.2084 18.3116,8.1024 L17.707,8.707 C17.5117,8.9023 17.2559,9 17,9 C16.7441,9 16.4883,8.9023 16.293,8.7071 C15.9024,8.3164 15.9024,7.6836 16.293,7.293 L16.8976,6.6884 C15.7916,5.8282 14.4575,5.2525 13,5.0695 L13,6 C13,6.5522 12.5522,7 12,7 C11.4478,7 11,6.5522 11,6 L11,5.0695 C9.5425,5.2524 8.2084,5.8282 7.1024,6.6884 L7.707,7.2929 C8.0976,7.6836 8.0976,8.3164 7.707,8.707 C7.5117,8.9023 7.2559,9 7,9 C6.7441,9 6.4883,8.9023 6.293,8.707 L5.6884,8.1024 C4.8282,9.2084 4.2525,10.5425 4.0695,12 L5,12 C5.5522,12 6,12.4478 6,13 C6,13.5522 5.5522,14 5,14 L4.0704,14 C4.2726,15.6051 4.9506,17.1163 6.0435,18.3316 C6.4126,18.7422 6.3789,19.3746 5.9683,19.7437 C5.5577,20.1138 4.9258,20.0791 4.5562,19.6685 C2.9077,17.8354 2,15.4673 2,13 C2,7.4858 6.4858,3 12,3 Z M14.2929,10.293 C14.6836,9.9024 15.3164,9.9024 15.707,10.293 C16.0977,10.6836 16.0977,11.3164 15.7071,11.707 L13.9257,13.4884 C13.9693,13.6526 14,13.822 14,14 C14,15.1046 13.1046,16 12,16 C10.8954,16 10,15.1046 10,14 C10,12.8954 10.8954,12 12,12 C12.178,12 12.3474,12.0307 12.5115,12.0744 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPerformanceNormal);
export default __webpack_public_path__ + "static/media/NavPerformanceNormal.9f6f1aaf12da1c72a6a9f1007016ed97.svg";
export { ForwardRef as ReactComponent };